import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		loading: {
			height: "50vh",
		}
	} satisfies Record<string, CSSObject>)